// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

function StartFirebase() {
  const firebaseConfig = {
    apiKey: "AIzaSyCKRfSqkbW4rSZWJ7MbAHYvCDp7XdNErug",
    authDomain: "critters-d4958.firebaseapp.com",
    projectId: "critters-d4958",
    storageBucket: "critters-d4958.appspot.com",
    messagingSenderId: "700651937097",
    appId: "1:700651937097:web:1cd659bcc1011c0df10e98",
    measurementId: "G-RZELY3WQCK",
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  return getDatabase(app);
}

export default StartFirebase;
